/*
 * File: FilterFields.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: The list of filter sections for orders. A `value` of null indicates that all options should be checked, otherwise `value` should be an array of selected ids. `options` is for sections which are not pulled from the server.
 */
import OrderFormOptions from "./store/OrderFormOptions";

const FilterFields = [
  {
    name: "offices",
    label: "Offices",
    hasCheckAll: true,
    type: "checkboxgroup",
    value: null
  },
  {
    name: "providers",
    label: "Providers",
    hasCheckAll: true,
    type: "checkboxgroup",
    value: null
  },
  {
    name: "types",
    label: "Order Types",
    hasCheckAll: true,
    type: "checkboxgroup",
    value: null
  },
  {
    name: "statuses",
    label: "Order Statuses",
    hasCheckAll: true,
    type: "checkboxgroup",
    value: OrderFormOptions.getDefaultStatuses().map(s => s.id)
  },
  {
    name: "signed",
    label: "Signed and Unsigned",
    hasCheckAll: true,
    type: "checkboxgroup",
    value: null,
    options: OrderFormOptions.getSigned()
  }
];

export default FilterFields;
